import { useCloseCompactMessengerWhenLeavingDealRoute } from 'utils/hooks/useCloseCompactMessengerWhenLeavingDealRoute';
import { useMessengerInit } from 'utils/hooks/useMessengerInit';

/** Keeps messenger deeplink + event listeners active when compact MFE is mounted outside SideOverlayContainer. */
export const MessengerHostInit = () => {
  useMessengerInit();
  useCloseCompactMessengerWhenLeavingDealRoute();

  return null;
};
